import React from "react";

const TotalQuantityIcon = ({ width, height, color }) => {
  return (
    <svg
      width="33"
      height="30"
      viewBox="0 0 33 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7.08333" cy="22.9167" r="7.08333" fill="#435CFF" />
      <circle cx="16.2498" cy="7.08333" r="7.08333" fill="#435CFF" />
      <circle cx="25.4168" cy="22.9167" r="7.08333" fill="#435CFF" />
    </svg>
  );
};
export default TotalQuantityIcon;
